import React from 'react';
import classNames from 'classnames';
import styles from './Header.scss';

const CodeEditorTitle = ({ theme }) => {
  const isDarkTheme = theme === 'vs-dark';

  return (
    <div
      className={classNames({
        [styles['white-text']]: isDarkTheme,
        [styles['black-text']]: !isDarkTheme,
        [styles.headerLeft]: true,
      })}
      style={{ fontSize: '16px' }}
    >
      Code Editor
    </div>
  );
};

export default CodeEditorTitle;
